module.exports = __webpack_public_path__ + "media/application/images/ui/endorsement_top-brand-dd4f1afd785233d0ee320260de41b9ab.svg";